import { SlotRepository } from '../../api/repository/slot';
import type { QltSlot } from '../../api/types';
import { createResourceStore } from './resource-store';

export const useQltSlotStore = createResourceStore<QltSlot>(SlotRepository);
